import { useTranslation } from 'react-i18next';

import { VideoNoticesTable } from '@admin/components/video-notices/video-notices-table.tsx';

/**
 * Page Admin en lecture seule permettant de rechercher et consulter les notices publiées.
 */
export function VideoInstructionsLibrary() {
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <h1 className="text-4xl font-bold">{t('admin.video.notices.page.title')}</h1>
        <p className="text-muted-foreground">{t('admin.video.notices.page.description')}</p>
      </div>

      <VideoNoticesTable
        canManage={false}
        showSearch
        listTitle={t('admin.video.notices.list.title')}
      />
    </div>
  );
}
